











import Vue from 'vue';
import { IProductVariant } from '../../../../common/interfaces/products.interface';

export default Vue.extend({
  name: `ProductVariantSize`,
  computed: {
    text(): string {
      switch(this.productVariant.unit) {
        case 1:
        case 2:
          return `${this.productVariant.size} ${this.unit}`;
        case 3:
          return this.unit;
        case 4:
        case 5:
          return `${this.unit} ${this.productVariant.size}`;
        case 6:
          return `${this.productVariant.size} ${this.unit}`;
        default:
          return ``;
      }
    },

    unit(): string {
      switch(this.productVariant.unit) {
        case 1:
          return this.$t(`products-ufe:variants.units.caps`);
        case 2:
          return this.$t(`products-ufe:variants.units.gram`);
        case 3:
          return this.$t(`products-ufe:variants.units.trial`);
        case 4:
          return this.$t(`products-ufe:variants.units.set`);
        case 5:
          return this.$t(`products-ufe:variants.units.amount`);
        case 6:
          return this.$t(`products-ufe:variants.units.milliliter`);
        default:
          return ``;
      }
    },
  },
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    productVariant: {
      required: true,
      type: Object as () => IProductVariant,
    },
  },
  methods: {
    selectVariant(): void {
      if(!this.active) {
        this.$emit(`select:variant`);
      }
    },
  },
});
